import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FormSelect } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Template + report select row for the letter composer. */
export function LetterComposerSelects(_ref) {
  var composerId = _ref.composerId,
    templateOptions = _ref.templateOptions,
    reportOptions = _ref.reportOptions,
    templateId = _ref.templateId,
    reportId = _ref.reportId,
    lockTemplate = _ref.lockTemplate,
    isPreview = _ref.isPreview,
    templatesLoading = _ref.templatesLoading,
    reportsLoading = _ref.reportsLoading,
    onTemplateChange = _ref.onTemplateChange,
    onReportChange = _ref.onReportChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 gap-3 sm:grid-cols-2"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    label: t("template", {
      defaultValue: "Template"
    }),
    placeholder: t("select_template", {
      defaultValue: "Select a template"
    }),
    data: templateOptions,
    value: templateId,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.LETTER_TEMPLATE_SELECT, {
        composerId: composerId
      });
      onTemplateChange(value);
    },
    searchable: true,
    clearable: !lockTemplate,
    withinPortal: true,
    nothingFound: t("no_template_available", {
      defaultValue: "No template available"
    }),
    disabled: Boolean(templatesLoading || isPreview || lockTemplate),
    "data-testid": "letter-template-select"
  }), /*#__PURE__*/React.createElement(FormSelect, {
    label: t("report", {
      defaultValue: "Report"
    }),
    placeholder: t("select_report", {
      defaultValue: "Select a report"
    }),
    data: reportOptions,
    value: reportId,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.LETTER_REPORT_SELECT, {
        composerId: composerId
      });
      onReportChange(value);
    },
    searchable: true,
    clearable: true,
    withinPortal: true,
    nothingFound: t("no_report_available", {
      defaultValue: "No report available"
    }),
    disabled: Boolean(reportsLoading || isPreview),
    "data-testid": "letter-report-select"
  }));
}